// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
// DEV-89 (`oq-ММБ-121` (а)): запоминаем, куда человек шёл, — после входа он
// вернётся туда же (путь вместе с параметрами). Значение проверяется при чтении:
// только внутренний путь своего приложения, см. `utils/returnPath.ts`.
import { rememberReturnPath, forgetReturnPath } from './utils/returnPath';

const ProtectedRoute = ({ element, allowedRoles, isAuthenticated, userRole }) => {
  if (!isAuthenticated) {
    // Запоминаем до перехода: `<Navigate>` ниже подменяет адрес на страницу входа,
    // и вместе с ним терялся бы исходный путь.
    if (typeof window !== 'undefined') {
      rememberReturnPath(`${window.location.pathname}${window.location.search}`);
    }

    return <Navigate to="/" replace />;
  }

  if (!allowedRoles.includes(userRole)) {
    // `АУД-Н156`: «доступа нет» — тупик, а не адрес возврата. Забываем
    // запомненный путь: иначе после следующего входа человек вернётся сюда же и
    // снова увидит «нет доступа» — возврат зациклится.
    forgetReturnPath();

    return <Navigate to="/unauthorized" replace />;
  }

  return element;
};

export default ProtectedRoute;
